
import React from 'react';
import { motion } from 'framer-motion';

type ScheduleItem = {
  day: string;
  hours: string;
  open: boolean;
};

const schedule: ScheduleItem[] = [
  { day: 'Pazartesi', hours: '08:00 – 18:00', open: true },
  { day: 'Salı', hours: '08:00 – 18:00', open: true },
  { day: 'Çarşamba', hours: '08:00 – 18:00', open: true },
  { day: 'Perşembe', hours: '08:00 – 18:00', open: true },
  { day: 'Cuma', hours: '08:00 – 18:00', open: true },
  { day: 'Cumartesi', hours: '09:00 – 15:00', open: true },
  { day: 'Pazar', hours: 'Kapalı', open: false },
];

/**
 * Returns the current day name in Turkish.
 * Falls back to 'Pazar' if the Date object fails for any reason.
 */
function getCurrentDay(): string {
  const days = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
  try {
    return days[new Date().getDay()] ?? 'Pazar';
  } catch {
    // Defensive fallback – should never happen in a browser environment
    return 'Pazar';
  }
}

export default function WorkingHours() {
  const today = getCurrentDay();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="bg-white rounded-2xl p-7 shadow-sm"
    >
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 flex items-center justify-center bg-red-50 rounded-xl">
          <i className="ri-time-line text-xl text-red-600" aria-hidden="true"></i>
        </div>
        <div>
          <h3 className="text-base font-bold text-gray-900">Çalışma Saatleri</h3>
          <p className="text-xs text-gray-500 mt-0.5">Acil durumlar için 7/24 destek</p>
        </div>
      </div>

      <div className="space-y-0">
        {schedule.map((row) => {
          const isToday = row.day === today;
          return (
            <div
              key={row.day}
              className={`flex items-center justify-between py-3 border-b border-gray-100 last:border-0 ${
                isToday ? 'bg-red-50/60 -mx-3 px-3 rounded-lg' : ''
              }`}
            >
              <div className="flex items-center gap-2">
                {isToday && (
                  <span className="w-1.5 h-1.5 bg-red-500 rounded-full flex-shrink-0"></span>
                )}
                <span
                  className={`text-sm ${isToday ? 'font-semibold text-gray-900' : 'text-gray-700'}`}
                >
                  {row.day}
                </span>
                {isToday && (
                  <span className="text-[10px] font-semibold text-red-600 bg-red-100 px-1.5 py-0.5 rounded-full uppercase tracking-wider">
                    Bugün
                  </span>
                )}
              </div>
              <span
                className={`text-sm ${
                  row.open
                    ? isToday
                      ? 'font-semibold text-gray-900'
                      : 'text-gray-600'
                    : 'text-gray-400'
                }`}
              >
                {row.hours}
              </span>
            </div>
          );
        })}
      </div>

      <div className="mt-5 p-4 bg-red-50 rounded-xl">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 flex items-center justify-center bg-red-100 rounded-lg flex-shrink-0 mt-0.5">
            <i className="ri-alarm-warning-line text-sm text-red-600" aria-hidden="true"></i>
          </div>
          <div>
            <p className="text-sm font-semibold text-red-800">Acil Durum Hattı</p>
            <p className="text-xs text-red-600 mt-0.5">
              Yangın ve acil durumlar için <strong>7/24</strong> destek hattımız aktiftir.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
